/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Validation_Company_Person_Identifier_ConflictInputs */

const en_case_validation_company_person_identifier_conflict = /** @type {(inputs: Case_Validation_Company_Person_Identifier_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A company debtor cannot have CPF, RG, or CNH identifiers.`)
};

const pt_br2_case_validation_company_person_identifier_conflict = /** @type {(inputs: Case_Validation_Company_Person_Identifier_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um devedor pessoa jurídica não pode ter CPF, RG ou CNH.`)
};

/**
* | output |
* | --- |
* | "A company debtor cannot have CPF, RG, or CNH identifiers." |
*
* @param {Case_Validation_Company_Person_Identifier_ConflictInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_validation_company_person_identifier_conflict = /** @type {((inputs?: Case_Validation_Company_Person_Identifier_ConflictInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Validation_Company_Person_Identifier_ConflictInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_validation_company_person_identifier_conflict(inputs)
	return pt_br2_case_validation_company_person_identifier_conflict(inputs)
});